import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'

export const VappTypeDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [
    'id',
    'name',
    'description',
    'created_at',
    'updated_at',
    'archived_at',
  ],
  subscriptions: {
    items: 'VappTypesChannel',
  },
  defaultColumns: [
    'name',
    'description',
    'createdDatetime',
    'updatedDatetime',
  ],
  columnConfig: {
    name: {
      label: 'Name',
      header: {
        sort: 'name',
      },
      cell: {
        kind: 'simple',
        path: 'name',
      },
    },
    description: {
      label: 'Description',
      header: {
        sort: 'description',
      },
      cell: {
        kind: 'simple',
        path: 'description',
      },
    },
    createdDatetime: {
      label: 'Created Datetime',
      header: {
        sort: 'created_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.createdAt }),
      },
    },
    createdDate: {
      label: 'Created Date',
      header: {
        sort: 'created_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.createdAt, format: 'dateOnly' }),
      },
    },
    createdTime: {
      label: 'Created Time',
      header: {
        sort: 'created_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.createdAt, format: 'timeOnly' }),
      },
    },
    updatedDatetime: {
      label: 'Updated Datetime',
      header: {
        sort: 'updated_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.updatedAt }),
      },
    },
    updatedDate: {
      label: 'Updated Date',
      header: {
        sort: 'updated_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.updatedAt, format: 'dateOnly' }),
      },
    },
    updatedTime: {
      label: 'Updated Time',
      header: {
        sort: 'updated_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.updatedAt, format: 'timeOnly' }),
      },
    },
  },
}
